import { Suspense } from 'react'

import Navbar from './Navbar'
import PreNav from './PreNav'

import type { FC } from 'react'
import type { IPreferencesData } from '@/types'

const Header: FC<{ contacts: IPreferencesData[] }> = ({ contacts }) => {
  return (
    <header className="fixed left-0 z-50 w-full bg-white transition-all duration-500 ease-in">
      <PreNav contacts={contacts} />
      <Suspense>
        <Navbar contacts={contacts} />
      </Suspense>
    </header>
  )
}

export default Header
